module.exports = __webpack_public_path__ + "static/media/magazine-480w.c15aed4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Projects/DS/assets/magazine-480w.png
// module id = 157
// module chunks = 0